import { render } from "./UGCCreatorInfo.vue?vue&type=template&id=8b12664c"
import script from "./UGCCreatorInfo.vue?vue&type=script&lang=js"
export * from "./UGCCreatorInfo.vue?vue&type=script&lang=js"

import "./UGCCreatorInfo.vue?vue&type=style&index=0&id=8b12664c&lang=css"

import exportComponent from "/var/www/ab-front-library/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__